<template>
	<v-expansion-panels>
		<v-expansion-panel>
			<v-expansion-panel-header>
				{{ $t("Filter") }}
			</v-expansion-panel-header>
			<v-divider></v-divider>
			<v-expansion-panel-content>
				<v-layout row wrap class="pt-2">
					<v-flex xs12 md3>
						<v-autocomplete :items="customers" item-value="id" :item-text="'display_name'" :label="$t('label.customer')" v-model="filter.customer_id" clearable hide-details>
						</v-autocomplete>
					</v-flex>
					<v-flex xs12 md3>
						<v-autocomplete :items="memberships" item-value="id" :item-text="'name'" :label="$t('label.memberships')" v-model="filter.membership_id" clearable hide-details>
						</v-autocomplete>
					</v-flex>
					<v-flex xs12 md3>
						<v-select v-model="filter.state" :items="states" :label="$t('label.state')" hide-details clearable></v-select>
					</v-flex>
				</v-layout>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>
<script>
	export default {
		props: ["value", "customers", "memberships"],

		data() {
			return {
				states: [
					{
						text: "Pending",
						value: "pending",
					},
					{
						text: "Approved",
						value: "approved",
					},
					{
						text: "Suspended",
						value: "suspended",
					},
					{
						text: "Canceled",
						value: "canceled",
					},
					{
						text: "Expired",
						value: "expired",
					},
				],
			};
		},

		computed: {
			filter: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
		watch: {
			filter: {
				handler() {
					this.$emit("filter");
				},
				deep: true,
			},
		},
	};
</script>